<template>
  <div id="admin-app" v-resize="onResize">
    <router-view v-if="isRouterAlive"/>
  </div>
</template>

<script>
export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload,
    }
  },
  data() {
    return {
      isRouterAlive: true,
    }
  },
  computed: {
    miniWidth() {
      return this.$store.state.miniWidth
    },
  },
  methods: {
    onResize() {
      const mini = window.innerWidth <= 768
      if (mini !== this.miniWidth) {
        mini && this.$store.commit('SET_OPENED', false)
        this.$store.commit('SET_MINI_WIDTH', mini)
      }
    },
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
  },
}
</script>
<style lang="scss">

    .amap-info-content {
        line-height: 1.15;
    }

    .el-table--enable-row-hover .el-table__body tr:hover > td {
        background-color: #aaa !important;
        color: #fff !important;
    }

    .el-dialog__body {
        padding: 5px 20px !important;
    }
    .tabs-fx {
         .el-dialog__body {
        padding: 30px 20px!important;
    }
    }

    .order-trajectory .el-card__body {
        padding: 10px 15px !important;
    }

    .mead-bike-map .el-card__body {
        height: calc(100% - 80px) !important;
        padding: 10px 15px !important;
    }

    .mead-tabs-class .el-tabs__content{
        padding: 15px 0!important;
    }
</style>
